import React from "react";
import { Link } from "react-router-dom";
import Card from "./Card";
import "./Cards.css";
import { useEventHistoryQuery } from "../queries/eventHistory";

export default function EventHistory() {
  const query = useEventHistoryQuery();
  const events = query.data?.pages.flat() ?? [];
  return <div>
    <div className="category-title"><h1>Minione wydarzenia</h1><p>Historia wydarzeń, które odbyły się w Krakowie.</p></div>
    {query.isLoading ? <div className="loader" /> : query.isError ? (
      <div className="cards-bottom-text">
        <p>Nie udało się pobrać minionych wydarzeń.</p>
        <button className="btn btn-outline-primary" onClick={() => query.refetch()}>Spróbuj ponownie</button>
      </div>
    ) : events.length ? <div className="card-deck card-deck-cards">{events.map(event => <Card key={`${event.archiveSource || "event"}-${event._id}`} cardsCategory="events" event={event} />)}</div> : <div className="cards-bottom-text"><p>Brak minionych wydarzeń.</p></div>}
    {query.hasNextPage && <div className="cards-bottom-text"><button className="btn btn-outline-primary" onClick={() => query.fetchNextPage()} disabled={query.isFetchingNextPage}>{query.isFetchingNextPage ? "Ładowanie…" : "Pokaż więcej"}</button></div>}
    <div className="cards-bottom-text"><Link to="/eventy">Wróć do bieżących wydarzeń</Link></div>
  </div>;
}
